import { useEffect, useMemo, useState } from 'react'
import { supportedLocales, translations } from './translations'

const normalizeLocale = (value) => (supportedLocales.includes(value) ? value : 'en')

const getStoredLocale = () => {
  if (typeof window === 'undefined') return 'en'
  return normalizeLocale(window.localStorage.getItem('lang') || 'en')
}

const interpolate = (message, values = {}) =>
  Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, value),
    message
  )

export const useTranslation = () => {
  const [locale, setLocale] = useState(getStoredLocale)
  const dir = locale === 'ar' ? 'rtl' : 'ltr'

  useEffect(() => {
    document.documentElement.lang = locale
    document.documentElement.dir = dir
  }, [dir, locale])

  useEffect(() => {
    const handleStorage = () => setLocale(getStoredLocale())
    window.addEventListener('storage', handleStorage)
    return () => window.removeEventListener('storage', handleStorage)
  }, [])

  return useMemo(
    () => ({
      dir,
      locale,
      t: (key, values) =>
        interpolate(translations[locale]?.[key] || translations.en[key] || key, values),
    }),
    [dir, locale]
  )
}
